const preTags = [
    'Action', 
    'Adult', 
    'Adventure', 
    'Animation',
    'Anime',
    'Biography', 
    'Cdrama',
    'Comedy', 
    'Crime', 
    'Documentary', 
    'Drama', 
    'Family', 
    'Fantasy', 
    'Game-Show', 
    'History', 
    'Horror', 
    'Indie Shorts',
    'Kdrama',
    'Music', 
    'Musical', 
    'Mystery', 
	'News', 
    'Reality-Tv', 
    'Romance', 
    'Sci-Fi', 
    'Short', 
    'Short Film',
    'Sport', 
    'Superhero',
    'Talk-Show', 
    'Thriller', 
    'War', 
    'Western', 
];


export default preTags